var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "parts_table mt-4" }, [
    _c("div", { staticClass: "push_item mb-4" }, [
      _c("div", [
        _c(
          "button",
          {
            staticClass:
              "btn btn-lg btn-default waves-effect waves-themed width-xl",
            attrs: { type: "button" },
            on: {
              click: function ($event) {
                return _vm.add_row(false)
              },
            },
          },
          [
            _c("span", { staticClass: "fal fa-plus mr-1" }),
            _vm._v("\n\t\t\t\tЗа каталогом\n\t\t\t"),
          ]
        ),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "mt-2" }, [
        _c(
          "button",
          {
            staticClass:
              "btn btn-lg width-xl btn-outline-info waves-effect waves-themed",
            attrs: { type: "button" },
            on: { click: _vm.add_manual_row },
          },
          [
            _c("span", { staticClass: "fal fa-plus mr-1" }),
            _vm._v("\n\t\t\t\tВручну\n\t\t\t"),
          ]
        ),
      ]),
    ]),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "head" },
      [
        _c("b-table", {
          attrs: {
            "head-variant": "dark",
            "tbody-tr-class": _vm.checkRow,
            items: _vm.part_fields_items,
            fields: _vm.fields,
          },
          scopedSlots: _vm._u([
            {
              key: "cell(name)",
              fn: function (data) {
                return [
                  _c("b-form-input", {
                    staticClass: "fs-xl",
                    attrs: {
                      type: "text",
                      readonly: !data.item.is_manual,
                      disabled: parseInt(data.item.id) > 0,
                      value: "data.name",
                      size: "sm",
                    },
                    model: {
                      value: data.item.name,
                      callback: function ($$v) {
                        _vm.$set(data.item, "name", $$v)
                      },
                      expression: "data.item.name",
                    },
                  }),
                ]
              },
            },
            {
              key: "cell(numberOriginal)",
              fn: function (data) {
                return [
                  _c(
                    "div",
                    [
                      data.item.is_manual == false &&
                      parseInt(data.item.id) == 0
                        ? _c("part_item", {
                            key: "idx_" + data.index,
                            attrs: { table_item: data, item_type: "original" },
                            on: { on_select_part: _vm.on_select_part },
                          })
                        : _c("b-form-input", {
                            staticClass: "fs-xl",
                            attrs: {
                              type: "text",
                              placeholder: "Каталожний номер",
                              disabled: parseInt(data.item.id) > 0,
                              value: "data.name",
                              size: "sm",
                            },
                            model: {
                              value: data.item.numberOriginal,
                              callback: function ($$v) {
                                _vm.$set(data.item, "numberOriginal", $$v)
                              },
                              expression: "data.item.numberOriginal",
                            },
                          }),
                    ],
                    1
                  ),
                ]
              },
            },
            {
              key: "cell(qty)",
              fn: function (data) {
                return [
                  _c("b-form-input", {
                    staticClass: "fs-xl",
                    attrs: { type: "text", placeholder: "К-ть", size: "sm" },
                    model: {
                      value: data.item.qty,
                      callback: function ($$v) {
                        _vm.$set(data.item, "qty", $$v)
                      },
                      expression: "data.item.qty",
                    },
                  }),
                ]
              },
            },
            {
              key: "cell(measure)",
              fn: function (data) {
                return [
                  _c("b-form-input", {
                    staticClass: "fs-xl",
                    attrs: {
                      type: "text",
                      disabled: parseInt(data.item.id) > 0,
                      readonly: !data.item.is_manual,
                      placeholder: "Од. виміру",
                      size: "sm",
                    },
                    model: {
                      value: data.item.measure,
                      callback: function ($$v) {
                        _vm.$set(data.item, "measure", $$v)
                      },
                      expression: "data.item.measure",
                    },
                  }),
                ]
              },
            },
            {
              key: "cell(code)",
              fn: function (data) {
                return [
                  _c(
                    "div",
                    {
                      staticClass: "remove_row",
                      on: {
                        click: function ($event) {
                          return _vm.remove_row(data.index)
                        },
                      },
                    },
                    [
                      _c("i", {
                        staticClass:
                          "fa fa-trash active color-danger-800 cursor-pointer fs-xl mt-2 ml-1",
                        attrs: { "aria-hidden": "true" },
                      }),
                    ]
                  ),
                ]
              },
            },
          ]),
        }),
      ],
      1
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }